/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { logSafeErrorWithoutCustomerDataWrapper } from '@jira/polaris__lib-logging/src/logSafeErrorWithoutCustomerDataWrapper.tsx';
import { getUserProperty } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { isClientFetchError } from '@atlassian/jira-fetch/src/utils/is-error.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { PRODUCT_START_TIMESTAMP } from '../../constants.tsx';
import type { Props, State } from '../../types.tsx';

export const loadProductUsageStartTimestamp =
	(): Action<State, Props, Promise<string | undefined>> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		// usage timestamp already loaded
		if (getState().productUsageStartTimestamp) {
			return;
		}

		try {
			const { isoDateString: productUsageStartTimestamp } = await getUserProperty<{
				isoDateString: string;
			}>(accountId, PRODUCT_START_TIMESTAMP);

			const state = getState();

			setState({
				...state,
				productUsageStartTimestamp,
			});
		} catch (error) {
			if ((error instanceof FetchError && error.statusCode === 404) || isClientFetchError(error)) {
				return;
			}

			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.roadmaps.introduction.spotlight.dismissed',
				`Failed to get user property with key: ${PRODUCT_START_TIMESTAMP}`,
				error instanceof Error ? error : undefined,
			);
		}
		return getState().productUsageStartTimestamp;
	};
